module.exports = __webpack_public_path__ + "media/img/frontend_application/Balon-6dd76ec0bf406c7e4844cabebbc032f8.svg";